

















import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { ScoutingPlace } from "../../models";
import VCheckbox from "@/components/VCheckbox.vue";
import StoreSubscriber from "@/utils/StoreSubscriber";

@Component({ components: { VCheckbox } })
export default class ScoutingPlaceSelectableItem extends Vue {
  @Prop({ required: true }) readonly scoutingPlace!: ScoutingPlace;
  @Prop({ required: true }) readonly value!: boolean;

  private selected = this.value;

  @Watch("value")
  onValueChanged() {
    this.selected = this.value;
  }

  @Watch("selected")
  onSelectedChanged() {
    this.$emit("input", this.selected);
  }

  mounted() {
    this.subscribe();
  }

  subscribe() {
    StoreSubscriber.subscribe(
      "currentScouting/$updateSelectionScoutingPlace",
      this.onScoutingPlaceUpdateSelection.bind(this)
    );
  }

  onScoutingPlaceUpdateSelection(payload: ScoutingPlace) {
    if (payload && this.scoutingPlace.id === payload.id) {
      this.selected = payload.highlighted;
    }
  }
}
